export const FEATURE_NAME = '@zerops/zerops/feature/ws-reconnect';
